import { AxiosError } from 'axios';
import { useMutation, useQueryClient } from 'react-query';

import { createSurchargesMaintenanceDetails } from 'RestAPIs/admin';

import { showSuccessSnackbar } from 'components/shared/Snackbar';
import showError from 'components/shared/showError';

export const useCreateDetailsMutation = (handleClose?: () => void) => {
  const queryClient = useQueryClient();
  const { mutate, isLoading } = useMutation(
    createSurchargesMaintenanceDetails,
    {
      onSuccess: async () => {
        await queryClient.invalidateQueries({
          queryKey: ['surcharges-dyn']
        });
        handleClose && handleClose();
        showSuccessSnackbar();
      },
      onError: (error: AxiosError) => showError(error)
    }
  );

  return { mutate, isLoading };
};
